import React, { useState } from 'react';
import { LogoLink } from '../LogoLink';
import { MainNav } from './components/MainNav';
import {
    StyledMainMenu,
    StyledMainMenuContainer,
    StyledMainMenuWrapper
} from './style/MainMenu.styled';
import { NavControl } from './components/NavControl';

export const MainMenu = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuToggleHandler = () => setIsMenuOpen(!isMenuOpen);

    return (
        <StyledMainMenuContainer>
            <NavControl isOpen={isMenuOpen} onClick={menuToggleHandler} />
            <StyledMainMenuWrapper>
                <div className="overlay" onClick={menuToggleHandler} />
                <StyledMainMenu onClick={isMenuOpen ? menuToggleHandler : null}>
                    <LogoLink />
                    <MainNav />
                </StyledMainMenu>
            </StyledMainMenuWrapper>
        </StyledMainMenuContainer>
    );
};
